import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { FONT_FAMILY } from 'common/sharedFunctions';

// Modern tasarım renkleri
const modernColors = {
  primary: '#2563EB',
  secondary: '#F3F4F6',
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',
  textPrimary: '#1E293B',
  textSecondary: '#64748B',
  background: '#FFFFFF',
  surface: '#F9FAFB',
  border: '#E5E7EB',
  hover: '#EFF6FF',
  active: '#DBEAFE'
};

export default function DashboardCard(props) {
  const { title, value, icon, color = modernColors.primary, onClick } = props;

  return (
    <Card 
      elevation={0}
      onClick={onClick}
      sx={{ 
        backgroundColor: modernColors.background,
        borderRadius: '10px',
        padding: '20px',
        height: '100%',
        border: `1px solid ${modernColors.border}`,
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 10px 20px rgba(0,0,0,0.05)'
        }
      }}
    >
      <Box 
        sx={{ 
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }}
        >
          <Box 
            sx={{ 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '48px',
              height: '48px',
              borderRadius: '8px',
              backgroundColor: `${color}20`
            }}
          >
            {icon}
          </Box>
        </Box>
        <Typography variant="h6" sx={{ color: modernColors.textPrimary, fontWeight: 700, mb: 1, fontFamily: FONT_FAMILY }}>
          {value}
        </Typography>
        <Typography variant="body2" sx={{ color: modernColors.textSecondary, fontFamily: FONT_FAMILY }}>
          {title}
        </Typography>
      </Box>
    </Card>
  );
}
